<ngb-toast
  *ngFor="let toast of toastService.toasts"
  [class]="toast.classname"
  [autohide]="toast.autohide"
  (hidden)="toastService.remove(toast)">
  <div class="d-flex align-items-center justify-content-between">
    <span class="toast-text">{{ toast.message }}</span>
    <a href="#" class="link-dark">
      <i class="bi bi-x-lg" (click)="hide(toast)"></i>
    </a>
  </div>
</ngb-toast>